import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import { fetchUserValues } from '@app/src/views/EditUser/editUser/state/filterValues/actions';
import * as selectEditUser from '@app/src/views/EditUser/editUser/state/filterValues/selectors';
import { fetchEditUser } from '@app/src/views/EditUser/editUser/state/editUser/actions';
import * as selectValuesEditUser from '@app/src/views/EditUser/editUser/state/editUser/selectors';

const Container = reduxForm({
  form: 'editUser',
  enableReinitialize : true,
  onSubmit (fields, dispatch, { url }) {
    dispatch(fetchEditUser(fields, url));
  }
})(Form);

const mapStateToProps = state => ({
  isFetching: selectValuesEditUser.getIsFetching(state),
  message: selectEditUser.getMessage(state),
  sessionRol: selectEditUser.getSessionRol(state),
  idUser: selectEditUser.getIdUser(state),
  initialValues: {
    name: selectEditUser.getName(state),
    lastName: selectEditUser.getLastName(state),
    email: selectEditUser.getEmail(state),
    isAdmin: String(selectEditUser.getRol(state)),
    state: String(selectEditUser.getState(state))
  }
});

const mapDispatchToProps = dispatch => ({
  handlefetchUserValues : () => dispatch(fetchUserValues())
})

export const FormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
